import { Component } from '@angular/core';

@Component({
  selector: 'footer-bar',
  templateUrl: 'footer-bar.template.html'
})
export class FooterBarComponent { }
